'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _ImageErrorContent = require('./ImageErrorContent');

var _ImageErrorContent2 = _interopRequireDefault(_ImageErrorContent);

var _ImageUploaderContent = require('./ImageUploaderContent');

var _ImageUploaderContent2 = _interopRequireDefault(_ImageUploaderContent);

require('./ImageUploader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Styles


/**
 * Creates a component which enables the user to upload an image to the server.
 * This component will delegate the handling of uploading the file to the function passed in on the 'uploadImage'
 * property.
 */
var ImageUploader = function (_React$Component) {
    _inherits(ImageUploader, _React$Component);

    function ImageUploader() {
        _classCallCheck(this, ImageUploader);

        return _possibleConstructorReturn(this, (ImageUploader.__proto__ || Object.getPrototypeOf(ImageUploader)).apply(this, arguments));
    }

    _createClass(ImageUploader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                element = _props.element,
                imageIsHovered = _props.imageIsHovered,
                imageCanDrop = _props.imageCanDrop,
                imageConnectDropTarget = _props.imageConnectDropTarget;

            var error = element.getIn(['attachment', 'error']);

            var displayElement = error ? _react2.default.createElement(_ImageErrorContent2.default, _extends({ elementId: element.get('id'), error: error }, this.props)) : _react2.default.createElement(_ImageUploaderContent2.default, _extends({ elementId: element.get('id') }, this.props));

            var classes = (0, _classnames2.default)('ImageUploader drag-handle', {
                hovered: imageIsHovered && imageCanDrop
            });

            var renderUploader = _react2.default.createElement(
                'div',
                { className: classes },
                displayElement
            );

            return imageConnectDropTarget ? imageConnectDropTarget(renderUploader) : renderUploader;
        }
    }]);

    return ImageUploader;
}(_react2.default.Component);

ImageUploader.propTypes = {
    element: _propTypes2.default.object.isRequired,
    uploadImage: _propTypes2.default.func,
    imageIsHovered: _propTypes2.default.bool,
    imageCanDrop: _propTypes2.default.bool,
    imageConnectDropTarget: _propTypes2.default.func
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(ImageUploader);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/image/ImageUploader.js
// module id = 1982
// module chunks = 0